import React, {Component} from 'react';
import '../../../styles/Home.css'
import {Button} from "react-bootstrap";
import LoginService from "../../../admin/loginComponents/LoginService";
import Panel from "../Panel";
import {NotificationManager} from "react-notifications";

export default class ZmianaHasla extends Component {

    constructor(props) {
        super(props);

        this.state = {
            oldPass: '',
            newPass: '',
            newPass2: '',
            oldPassInvalid: false,
            shortPass: false,
            notSamePass: false,
            zmianaLoader: false
        };

        this.handleOldPass = this.handleOldPass.bind(this);
        this.handleNewPass = this.handleNewPass.bind(this);
        this.handleNewPass2 = this.handleNewPass2.bind(this)
    }

    handleOldPass(e) {
        this.setState({oldPass: e.target.value})
    }

    handleNewPass(e) {
        this.setState({newPass: e.target.value})
    }

    handleNewPass2(e) {
        this.setState({newPass2: e.target.value})
    }

    changePassword() {
        this.setState({notSamePass: false, shortPass: false, oldPassInvalid: false, zmianaLoader: true})
        if (this.state.oldPass !== JSON.parse(sessionStorage.getItem('loggedIn')).pass) {
            this.setState({oldPassInvalid: true, zmianaLoader: false})
        } else {
            if (this.state.newPass.length < 8) {
                this.setState({shortPass: true, oldPassInvalid: false, zmianaLoader: false})
            } else {
                if (this.state.newPass !== this.state.newPass2) {
                    this.setState({notSamePass: true, shortPass: false, oldPassInvalid: false, zmianaLoader: false})
                } else {
                    LoginService.changePassword(JSON.parse(sessionStorage.getItem('loggedIn')).idKl, this.state.oldPass, this.state.newPass)
                        .then(function (response) {
                            sessionStorage.removeItem('loggedIn');
                            sessionStorage.removeItem('koszyk');
                            window.location.replace("/login/zmiana-hasla");
                        }.bind(this)).catch(err => {
                        console.log(err);
                    });
                }
            }
        }
    }

    render() {
        return <Panel>
            <div>
                <h4 style={{textAlign: 'center', marginBottom: 20}}><b>Zmiana hasła</b></h4>

                <div className="row">
                    <div className="col-12 text-center">
                        <div className="row">
                            <div className="col-4 inputLabel">Stare hasło: <font color="red">*</font></div>
                            <div className="col-8 inputLogin text-left"><i className="fa fa-unlock-alt"
                                                                           style={{color: '#b0b0b0'}}> </i><input
                                className="form-control inputLoginControl" value={this.state.oldPass}
                                onChange={this.handleOldPass}
                                placeholder="Podaj stare hasło"
                                type="password"/></div>
                        </div>
                        <div className="row">
                            <div className="col-4 inputLabel">Nowe hasło: <font color="red">*</font></div>
                            <div className="col-8 inputLogin text-left">
                                <i className="fa fa-unlock-alt"> </i><input className="form-control inputLoginControl"
                                                                            value={this.state.newPass}
                                                                            onChange={this.handleNewPass}
                                                                            placeholder="Podaj nowe hasło"
                                                                            type="password"/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4 inputLabel">Powtórz nowe hasło: <font color="red">*</font></div>
                            <div className="col-8 inputLogin text-left"><i className="fa fa-unlock-alt"> </i><input
                                className="form-control inputLoginControl"
                                value={this.state.newPass2}
                                onChange={this.handleNewPass2}
                                placeholder="Powtórz nowe hasło" type="password"/></div>
                        </div>
                    </div>
                    <div className="col-12 text-center" style={{marginTop: 15}}>
                        <div className="buttonLogin"><Button bsStyle="success"
                                                             onClick={() => this.changePassword()}>Zmień hasło</Button>
                            {this.state.zmianaLoader ? <div className="loaderDim" style={{textAlign: 'center'}}><i
                                className="fa fa-spinner fa-pulse fa-fw"
                                style={{
                                    color: '#58b13d'
                                }}> </i></div> : null}
                        </div>
                        {this.state.oldPassInvalid ?
                            <div className="niepoprawneDaneOsobowe">Niepoprawne hasło.</div> : null}
                        {this.state.notSamePass ?
                            <div className="niepoprawneDaneOsobowe">Podane hasła nie są takie same.</div> : null}
                        {this.state.shortPass ?
                            <div className="niepoprawneDaneOsobowe">Hasło jest za krótkie.</div> : null}
                    </div>
                </div>
            </div>
        </Panel>
    }

}



// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/ZmianaHasla.js